import { render } from "./HasManyField.vue?vue&type=template&id=f871e438"
import script from "./HasManyField.vue?vue&type=script&lang=js"
export * from "./HasManyField.vue?vue&type=script&lang=js"

import exportComponent from "/www/yadonor/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HasManyField.vue"]])

export default __exports__